interface HudBarProps {
  value: number; // 0..1
  segments?: number;
  className?: string;
}

export function HudBar({ value, segments = 8, className = "" }: HudBarProps) {
  const filled = Math.max(0, Math.min(segments, Math.round(value * segments)));
  return (
    <div className={`flex gap-1 ${className}`} aria-hidden="true">
      {Array.from({ length: segments }).map((_, i) => (
        <span
          key={i}
          className={`h-1.5 flex-1 rounded-sm ${
            i < filled
              ? "bg-cyan shadow-[0_0_6px_rgba(0,229,255,0.5)]"
              : "bg-line"
          }`}
        />
      ))}
    </div>
  );
}